<template>
    <div>
        <b-modal ref="saveModal" :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" :title="actionTitle" size="lg" @ok="saveAction" @hidden="hideModal" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_progress_settings_steps'], ['update']))">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3" v-if="!row">
                        <div class="col-lg-4">
                            <label>{{ $t('table.step_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.step_no">
                                <option v-for="step in finalSteps" :value="step" :key="step">{{step}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="row != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.step_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" class="form-control" v-model="model.step_no" disabled>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.step_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.step_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="row != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.step_calendar') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" class="form-control" v-model="model.step_calendar" disabled>
                        </div>
                    </div>
                    
                    <span v-if="section == 'piping'">
                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.step_detail_calculation_work_value') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.step_detail_calculation_work_value">
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_1_step_detail_calculation_work_value') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_1_step_detail_calculation_work_value">
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_2_step_detail_calculation_work_value') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_2_step_detail_calculation_work_value">
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.step_weight_work_status') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.step_weight_work_status">
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_1_step_detail_weight') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_1_step_detail_weight">
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_2_step_detail_weight') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_2_step_detail_weight">
                            </div>
                        </div>

                        <div class="row mb-3" v-if="row != null">
                            <div class="col-lg-4">
                                <label>{{ $t('table.step_dia_inch_total') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" class="form-control" v-model="model.calculated.step_dia_inch_total" disabled>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.step_dia_inch_prefabrication') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.step_dia_inch_prefabrication">
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.step_dia_inch_erection') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.step_dia_inch_erection">
                            </div>
                        </div>

                        <div class="row mb-3" v-if="row != null">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_1_step_dia_inch_total') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" class="form-control" v-model="model.calculated.recovery_1_step_dia_inch_total" disabled>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_1_step_dia_inch_prefabrication') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_1_step_dia_inch_prefabrication">
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_1_step_dia_inch_erection') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_1_step_dia_inch_erection">
                            </div>
                        </div>
                    </span>
                </div>

                <div class="col-lg-6">
                    <span v-if="section == 'piping'">
                        <div class="row mb-3" v-if="row != null">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_2_step_dia_inch_total') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" class="form-control" v-model="model.calculated.recovery_2_step_dia_inch_total" disabled>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_2_step_dia_inch_prefabrication') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_2_step_dia_inch_prefabrication">
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_2_step_dia_inch_erection') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_2_step_dia_inch_erection">
                            </div>
                        </div>

                        <div class="row mb-3" v-if="row != null">
                            <div class="col-lg-4">
                                <label>{{ $t('table.step_bw_dia_inch_total') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" class="form-control" v-model="model.calculated.step_bw_dia_inch_total" disabled>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.step_bw_dia_inch_prefabrication') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.step_bw_dia_inch_prefabrication">
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.step_bw_dia_inch_erection') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.step_bw_dia_inch_erection">
                            </div>
                        </div>

                        <div class="row mb-3" v-if="row != null">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_1_step_bw_dia_inch_total') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" class="form-control" v-model="model.calculated.recovery_1_step_bw_dia_inch_total" disabled>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_1_step_bw_dia_inch_prefabrication') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_1_step_bw_dia_inch_prefabrication">
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_1_step_bw_dia_inch_erection') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_1_step_bw_dia_inch_erection">
                            </div>
                        </div>

                        <div class="row mb-3" v-if="row != null">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_2_step_bw_dia_inch_total') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" class="form-control" v-model="model.calculated.recovery_2_step_bw_dia_inch_total" disabled>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_2_step_bw_dia_inch_prefabrication') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_2_step_bw_dia_inch_prefabrication">
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_2_step_bw_dia_inch_erection') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_2_step_bw_dia_inch_erection">
                            </div>
                        </div>
                    </span>

                    <span v-if="section =='equipment'">
                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.steps_equipment') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.steps_equipment">
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_1_equipment') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_1_equipment">
                            </div>
                        </div>
                    </span>

                    <span v-if="section =='ei'">
                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.steps_ei') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.steps_ei">
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_1_ei') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_1_ei">
                            </div>
                        </div>
                    </span>

                    <span v-if="section =='steelstructure'">
                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.steps_steelstructure') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.steps_steelstructure">
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_1_steelstructure') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_1_steelstructure">
                            </div>
                        </div>
                    </span>

                    <span v-if="section =='civil'">
                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.steps_civil') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.steps_civil">
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_1_civil') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_1_civil">
                            </div>
                        </div>
                    </span>

                    <span v-if="section =='painting'">
                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.steps_painting') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.steps_painting">
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_1_painting') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_1_painting">
                            </div>
                        </div>
                    </span>

                    <span v-if="section =='insulation'">
                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.steps_insulation') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.steps_insulation">
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label>{{ $t('table.recovery_1_insulation') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.recovery_1_insulation">
                            </div>
                        </div>
                    </span>
                </div>
            </div>

            <hr v-if="hasHiddenColumnsPermission && row != null">

            <div class="row" v-if="hasHiddenColumnsPermission && row != null">
                <div class="col-lg-12">
                    <div class="row mb-3">
                        <div class="col-lg-6">
                            <label>{{ $t('table.ist_progress_total_work_value_calculation') }}</label>
                        </div>
                        <div class="col-lg-6">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.hidden_columns.ist_progress_total_work_value_calculation">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="section == 'piping'">
                        <div class="col-lg-6">
                            <label>{{ $t('table.ist_progress_total_work_value_status') }}</label>
                        </div>
                        <div class="col-lg-6">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.hidden_columns.ist_progress_total_work_value_status">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="section == 'piping'">
                        <div class="col-lg-6">
                            <label>{{ $t('table.ist_progress_total_weight_calculation') }}</label>
                        </div>
                        <div class="col-lg-6">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.hidden_columns.ist_progress_total_weight_calculation">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="section == 'piping'">
                        <div class="col-lg-6">
                            <label>{{ $t('table.ist_progress_total_weight_status') }}</label>
                        </div>
                        <div class="col-lg-6">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.hidden_columns.ist_progress_total_weight_status">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="section == 'piping'">
                        <div class="col-lg-6">
                            <label>{{ $t('table.ist_progress_dia_total_prefabrication') }}</label>
                        </div>
                        <div class="col-lg-6">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.hidden_columns.ist_progress_dia_total_prefabrication">
                        </div>
                    </div>
                    
                    <div class="row mb-3" v-if="section == 'piping'">
                        <div class="col-lg-6">
                            <label>{{ $t('table.ist_progress_dia_total_erection') }}</label>
                        </div>
                        <div class="col-lg-6">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.hidden_columns.ist_progress_dia_total_erection">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="section == 'piping'">
                        <div class="col-lg-6">
                            <label>{{ $t('table.ist_progress_bw_dia_total_prefabrication') }}</label>
                        </div>
                        <div class="col-lg-6">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.hidden_columns.ist_progress_bw_dia_total_prefabrication">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="section == 'piping'">
                        <div class="col-lg-6">
                            <label>{{ $t('table.ist_progress_bw_dia_total_erection') }}</label>
                        </div>
                        <div class="col-lg-6">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.hidden_columns.ist_progress_bw_dia_total_erection">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-6">
                            <label>{{ $t('table.current_execution_value_work_drawings') }}</label>
                        </div>
                        <div class="col-lg-6">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.hidden_columns.current_execution_value_work_drawings">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="section == 'piping'">
                        <div class="col-lg-6">
                            <label>{{ $t('table.current_weight_drawings') }}</label>
                        </div>
                        <div class="col-lg-6">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.hidden_columns.current_weight_drawings">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="section == 'piping'">
                        <div class="col-lg-6">
                            <label>{{ $t('table.current_total_dia_inch_drawings') }}</label>
                        </div>
                        <div class="col-lg-6">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.hidden_columns.current_total_dia_inch_drawings">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="section == 'piping'">
                        <div class="col-lg-6">
                            <label>{{ $t('table.current_total_bw_dia_inch_drawings') }}</label>
                        </div>
                        <div class="col-lg-6">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.hidden_columns.current_total_bw_dia_inch_drawings">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-6">
                            <label>{{ $t('table.real_hours') }}</label>
                        </div>
                        <div class="col-lg-6">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.hidden_columns.real_hours">
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    name: 'ProgressSettingStepsModal',
    components: {
        notificationIcons,
        flatPickr
    },
    props: {
        section: {
            type: String,
            required: true
        },
        tableName: {
            type: String,
            required: true
        },
        tableNameTranslated: {
            type: String,
            default: ''
        },
        finalSteps: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    data() {
        return {
            hasHiddenColumnsPermission: false,
            actionTitle: '',
            row: null,
            model: {
                step_no: null,
                step_date: null,
                step_calendar: null,
                step_detail_calculation_work_value: null,
                recovery_1_step_detail_calculation_work_value: null,
                recovery_2_step_detail_calculation_work_value: null,
                step_weight_work_status: null,
                recovery_1_step_detail_weight: null,
                recovery_2_step_detail_weight: null,
                step_dia_inch_prefabrication: null,
                step_dia_inch_erection: null,
                recovery_1_step_dia_inch_prefabrication: null,
                recovery_1_step_dia_inch_erection: null,
                recovery_2_step_dia_inch_prefabrication: null,
                recovery_2_step_dia_inch_erection: null,
                step_bw_dia_inch_prefabrication: null,
                step_bw_dia_inch_erection: null,
                recovery_1_step_bw_dia_inch_prefabrication: null,
                recovery_1_step_bw_dia_inch_erection: null,
                recovery_2_step_bw_dia_inch_prefabrication: null,
                recovery_2_step_bw_dia_inch_erection: null,
                steps_equipment: null,
                recovery_1_equipment: null,
                steps_ei: null,
                recovery_1_ei: null,
                steps_steelstructure: null,
                recovery_1_steelstructure: null,
                steps_civil: null,
                recovery_1_civil: null,
                steps_painting: null,
                recovery_1_painting: null,
                steps_insulation: null,
                recovery_1_insulation: null,
                calculated: {
                    step_dia_inch_total: null,
                    recovery_1_step_dia_inch_total: null,
                    recovery_2_step_dia_inch_total: null,
                    step_bw_dia_inch_total: null,
                    recovery_1_step_bw_dia_inch_total: null,
                    recovery_2_step_bw_dia_inch_total: null,
                },
                hidden_columns: {
                    ist_progress_total_work_value_calculation: null,
                    ist_progress_total_work_value_status: null,
                    ist_progress_total_weight_calculation: null,
                    ist_progress_total_weight_status: null,
                    ist_progress_dia_total_prefabrication: null,
                    ist_progress_dia_total_erection: null,
                    ist_progress_bw_dia_total_prefabrication: null,
                    ist_progress_bw_dia_total_erection: null,
                    current_execution_value_work_drawings: null,
                    current_weight_drawings: null,
                    current_total_dia_inch_drawings: null,
                    current_total_bw_dia_inch_drawings: null,
                    real_hours: null,
                }
            },
        }
    },
    mounted () {
        this.hasHiddenColumnsPermission = this.$store.getters.hasPermission(['project_progress_settings_steps_hidden_columns']);
    },
    methods: {
        errorMsg(msg, time = 5000) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), time);
        },
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        showModal () {
            this.$refs.saveModal.show();
        },
        hideModal () {
            this.clearSearches();
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.$refs.saveModal.show();
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;

            this.row                 = row;
            this.model.step_no       = this.row.step_no;
            this.model.step_date     = this.row.step_date;
            this.model.step_calendar = this.row.step_calendar;

            switch (this.section) {
                case 'piping':
                    this.model.step_detail_calculation_work_value            = this.row.step_detail_calculation_work_value;
                    this.model.recovery_1_step_detail_calculation_work_value = this.row.recovery_1_step_detail_calculation_work_value;
                    this.model.recovery_2_step_detail_calculation_work_value = this.row.recovery_2_step_detail_calculation_work_value;
                    this.model.step_weight_work_status                       = this.row.step_weight_work_status;
                    this.model.recovery_1_step_detail_weight                 = this.row.recovery_1_step_detail_weight;
                    this.model.recovery_2_step_detail_weight                 = this.row.recovery_2_step_detail_weight;
                    this.model.step_dia_inch_prefabrication                  = this.row.step_dia_inch_prefabrication;
                    this.model.step_dia_inch_erection                        = this.row.step_dia_inch_erection;
                    this.model.recovery_1_step_dia_inch_prefabrication       = this.row.recovery_1_step_dia_inch_prefabrication;
                    this.model.recovery_1_step_dia_inch_erection             = this.row.recovery_1_step_dia_inch_erection;
                    this.model.recovery_2_step_dia_inch_prefabrication       = this.row.recovery_2_step_dia_inch_prefabrication;
                    this.model.recovery_2_step_dia_inch_erection             = this.row.recovery_2_step_dia_inch_erection;
                    this.model.step_bw_dia_inch_prefabrication               = this.row.step_bw_dia_inch_prefabrication;
                    this.model.step_bw_dia_inch_erection                     = this.row.step_bw_dia_inch_erection;
                    this.model.recovery_1_step_bw_dia_inch_prefabrication    = this.row.recovery_1_step_bw_dia_inch_prefabrication;
                    this.model.recovery_1_step_bw_dia_inch_erection          = this.row.recovery_1_step_bw_dia_inch_erection;
                    this.model.recovery_2_step_bw_dia_inch_prefabrication    = this.row.recovery_2_step_bw_dia_inch_prefabrication;
                    this.model.recovery_2_step_bw_dia_inch_erection          = this.row.recovery_2_step_bw_dia_inch_erection;

                    this.model.calculated.step_dia_inch_total                = this.row.step_dia_inch_total;
                    this.model.calculated.recovery_1_step_dia_inch_total     = this.row.recovery_1_step_dia_inch_total;
                    this.model.calculated.recovery_2_step_dia_inch_total     = this.row.recovery_2_step_dia_inch_total;
                    this.model.calculated.step_bw_dia_inch_total             = this.row.step_bw_dia_inch_total;
                    this.model.calculated.recovery_1_step_bw_dia_inch_total  = this.row.recovery_1_step_bw_dia_inch_total;
                    this.model.calculated.recovery_2_step_bw_dia_inch_total  = this.row.recovery_2_step_bw_dia_inch_total;
                break;
                case 'equipment':
                    this.model.steps_equipment                               = this.row.steps_equipment;
                    this.model.recovery_1_equipment                          = this.row.recovery_1_equipment;
                break;
                case 'ei':
                    this.model.steps_ei                                      = this.row.steps_ei;
                    this.model.recovery_1_ei                                 = this.row.recovery_1_ei;
                break;
                case 'steelstructure':
                    this.model.steps_steelstructure                          = this.row.steps_steelstructure;
                    this.model.recovery_1_steelstructure                     = this.row.recovery_1_steelstructure;
                break;
                case 'civil':
                    this.model.steps_civil                                   = this.row.steps_civil;
                    this.model.recovery_1_civil                              = this.row.recovery_1_civil;
                break;
                case 'painting':
                    this.model.steps_painting                                = this.row.steps_painting;
                    this.model.recovery_1_painting                           = this.row.recovery_1_painting;
                break;
                case 'insulation':
                    this.model.steps_insulation                              = this.row.steps_insulation;
                    this.model.recovery_1_insulation                         = this.row.recovery_1_insulation;
                break;
            }

            if (this.hasHiddenColumnsPermission) {
                switch (this.section) {
                    case 'piping':
                        this.model.hidden_columns.ist_progress_total_work_value_calculation = this.row.ist_progress_total_work_value_calculation;
                        this.model.hidden_columns.ist_progress_total_work_value_status      = this.row.ist_progress_total_work_value_status;
                        this.model.hidden_columns.ist_progress_total_weight_calculation     = this.row.ist_progress_total_weight_calculation;
                        this.model.hidden_columns.ist_progress_total_weight_status          = this.row.ist_progress_total_weight_status;
                        this.model.hidden_columns.ist_progress_dia_total_prefabrication     = this.row.ist_progress_dia_total_prefabrication;
                        this.model.hidden_columns.ist_progress_dia_total_erection           = this.row.ist_progress_dia_total_erection;
                        this.model.hidden_columns.ist_progress_bw_dia_total_prefabrication  = this.row.ist_progress_bw_dia_total_prefabrication;
                        this.model.hidden_columns.ist_progress_bw_dia_total_erection        = this.row.ist_progress_bw_dia_total_erection;
                        this.model.hidden_columns.current_execution_value_work_drawings     = this.row.current_execution_value_work_drawings;
                        this.model.hidden_columns.current_weight_drawings                   = this.row.current_weight_drawings;
                        this.model.hidden_columns.current_total_dia_inch_drawings           = this.row.current_total_dia_inch_drawings;
                        this.model.hidden_columns.current_total_bw_dia_inch_drawings        = this.row.current_total_bw_dia_inch_drawings;
                        this.model.hidden_columns.real_hours                                = this.row.real_hours;
                    break;
                    case 'equipment':
                    case 'ei':
                    case 'steelstructure':
                    case 'civil':
                    case 'painting':
                    case 'insulation':
                        this.model.hidden_columns.ist_progress_total_work_value_calculation = this.row.ist_progress_total_work_value_calculation;
                        this.model.hidden_columns.current_execution_value_work_drawings     = this.row.current_execution_value_work_drawings;
                        this.model.hidden_columns.real_hours                                = this.row.real_hours;
                    break;
                }
            }

            this.$refs.saveModal.show();
        },
        clearSearches () {
            this.row                                                 = null;
            this.model.step_no                                       = null;
            this.model.step_date                                     = null;
            this.model.step_calendar                                 = null;
            this.model.step_detail_calculation_work_value            = null;
            this.model.recovery_1_step_detail_calculation_work_value = null;
            this.model.recovery_2_step_detail_calculation_work_value = null;
            this.model.step_weight_work_status                       = null;
            this.model.recovery_1_step_detail_weight                 = null;
            this.model.recovery_2_step_detail_weight                 = null;
            this.model.step_dia_inch_prefabrication                  = null;
            this.model.step_dia_inch_erection                        = null;
            this.model.recovery_1_step_dia_inch_prefabrication       = null;
            this.model.recovery_1_step_dia_inch_erection             = null;
            this.model.recovery_2_step_dia_inch_prefabrication       = null;
            this.model.recovery_2_step_dia_inch_erection             = null;
            this.model.step_bw_dia_inch_prefabrication               = null;
            this.model.step_bw_dia_inch_erection                     = null;
            this.model.recovery_1_step_bw_dia_inch_prefabrication    = null;
            this.model.recovery_1_step_bw_dia_inch_erection          = null;
            this.model.recovery_2_step_bw_dia_inch_prefabrication    = null;
            this.model.recovery_2_step_bw_dia_inch_erection          = null;
            this.model.steps_equipment                               = null;
            this.model.recovery_1_equipment                          = null;
            this.model.steps_ei                                      = null;
            this.model.recovery_1_ei                                 = null;
            this.model.steps_steelstructure                          = null;
            this.model.recovery_1_steelstructure                     = null;
            this.model.steps_civil                                   = null;
            this.model.recovery_1_civil                              = null;
            this.model.steps_painting                                = null;
            this.model.recovery_1_painting                           = null;
            this.model.steps_insulation                              = null;
            this.model.recovery_1_insulation                         = null;

            this.model.calculated.step_dia_inch_total                = null;
            this.model.calculated.recovery_1_step_dia_inch_total     = null;
            this.model.calculated.recovery_2_step_dia_inch_total     = null;
            this.model.calculated.step_bw_dia_inch_total             = null;
            this.model.calculated.recovery_1_step_bw_dia_inch_total  = null;
            this.model.calculated.recovery_2_step_bw_dia_inch_total  = null;

            this.model.hidden_columns.ist_progress_total_work_value_calculation = null;
            this.model.hidden_columns.ist_progress_total_work_value_status      = null;
            this.model.hidden_columns.ist_progress_total_weight_calculation     = null;
            this.model.hidden_columns.ist_progress_total_weight_status          = null;
            this.model.hidden_columns.ist_progress_dia_total_prefabrication     = null;
            this.model.hidden_columns.ist_progress_dia_total_erection           = null;
            this.model.hidden_columns.ist_progress_bw_dia_total_prefabrication  = null;
            this.model.hidden_columns.ist_progress_bw_dia_total_erection        = null;
            this.model.hidden_columns.current_execution_value_work_drawings     = null;
            this.model.hidden_columns.current_weight_drawings                   = null;
            this.model.hidden_columns.current_total_dia_inch_drawings           = null;
            this.model.hidden_columns.current_total_bw_dia_inch_drawings        = null;
            this.model.hidden_columns.real_hours                                = null;
        },
        saveAction (e) {
            e.preventDefault();

            let put_data = {
                project_id:          this.$route.params.id,
                progress_setting_id: this.$route.params.id2,
                section:             this.section,
                step_no:             this.model.step_no,
                step_date:           this.model.step_date,
            }

            switch (this.section) {
                case 'piping':
                    put_data['step_detail_calculation_work_value']            = this.model.step_detail_calculation_work_value;
                    put_data['recovery_1_step_detail_calculation_work_value'] = this.model.recovery_1_step_detail_calculation_work_value;
                    put_data['recovery_2_step_detail_calculation_work_value'] = this.model.recovery_2_step_detail_calculation_work_value;
                    put_data['step_weight_work_status']                       = this.model.step_weight_work_status;
                    put_data['recovery_1_step_detail_weight']                 = this.model.recovery_1_step_detail_weight;
                    put_data['recovery_2_step_detail_weight']                 = this.model.recovery_2_step_detail_weight;
                    put_data['step_dia_inch_prefabrication']                  = this.model.step_dia_inch_prefabrication;
                    put_data['step_dia_inch_erection']                        = this.model.step_dia_inch_erection;
                    put_data['recovery_1_step_dia_inch_prefabrication']       = this.model.recovery_1_step_dia_inch_prefabrication;
                    put_data['recovery_1_step_dia_inch_erection']             = this.model.recovery_1_step_dia_inch_erection;
                    put_data['recovery_2_step_dia_inch_prefabrication']       = this.model.recovery_2_step_dia_inch_prefabrication;
                    put_data['recovery_2_step_dia_inch_erection']             = this.model.recovery_2_step_dia_inch_erection;
                    put_data['step_bw_dia_inch_prefabrication']               = this.model.step_bw_dia_inch_prefabrication;
                    put_data['step_bw_dia_inch_erection']                     = this.model.step_bw_dia_inch_erection;
                    put_data['recovery_1_step_bw_dia_inch_prefabrication']    = this.model.recovery_1_step_bw_dia_inch_prefabrication;
                    put_data['recovery_1_step_bw_dia_inch_erection']          = this.model.recovery_1_step_bw_dia_inch_erection;
                    put_data['recovery_2_step_bw_dia_inch_prefabrication']    = this.model.recovery_2_step_bw_dia_inch_prefabrication;
                    put_data['recovery_2_step_bw_dia_inch_erection']          = this.model.recovery_2_step_bw_dia_inch_erection;
                break;
                case 'equipment':
                    put_data['steps_equipment']      = this.model.steps_equipment;
                    put_data['recovery_1_equipment'] = this.model.recovery_1_equipment;
                break;
                case 'ei':
                    put_data['steps_ei']      = this.model.steps_ei;
                    put_data['recovery_1_ei'] = this.model.recovery_1_ei;
                break;
                case 'steelstructure':
                    put_data['steps_steelstructure']      = this.model.steps_steelstructure;
                    put_data['recovery_1_steelstructure'] = this.model.recovery_1_steelstructure;
                break;
                case 'civil':
                    put_data['steps_civil']      = this.model.steps_civil;
                    put_data['recovery_1_civil'] = this.model.recovery_1_civil;
                break;
                case 'painting':
                    put_data['steps_painting']      = this.model.steps_painting;
                    put_data['recovery_1_painting'] = this.model.recovery_1_painting;
                break;
                case 'insulation':
                    put_data['steps_insulation']      = this.model.steps_insulation;
                    put_data['recovery_1_insulation'] = this.model.recovery_1_insulation;
                break;
            }

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });

            if (this.row != null) {
                if (this.hasHiddenColumnsPermission) {
                    switch (this.section) {
                        case 'piping':
                            put_data['ist_progress_total_work_value_calculation'] = this.model.hidden_columns.ist_progress_total_work_value_calculation;
                            put_data['ist_progress_total_work_value_status']      = this.model.hidden_columns.ist_progress_total_work_value_status;
                            put_data['ist_progress_total_weight_calculation']     = this.model.hidden_columns.ist_progress_total_weight_calculation;
                            put_data['ist_progress_total_weight_status']          = this.model.hidden_columns.ist_progress_total_weight_status;
                            put_data['ist_progress_dia_total_prefabrication']     = this.model.hidden_columns.ist_progress_dia_total_prefabrication;
                            put_data['ist_progress_dia_total_erection']           = this.model.hidden_columns.ist_progress_dia_total_erection;
                            put_data['ist_progress_bw_dia_total_prefabrication']  = this.model.hidden_columns.ist_progress_bw_dia_total_prefabrication;
                            put_data['ist_progress_bw_dia_total_erection']        = this.model.hidden_columns.ist_progress_bw_dia_total_erection;
                            put_data['current_execution_value_work_drawings']     = this.model.hidden_columns.current_execution_value_work_drawings;
                            put_data['current_weight_drawings']                   = this.model.hidden_columns.current_weight_drawings;
                            put_data['current_total_dia_inch_drawings']           = this.model.hidden_columns.current_total_dia_inch_drawings;
                            put_data['current_total_bw_dia_inch_drawings']        = this.model.hidden_columns.current_total_bw_dia_inch_drawings;
                            put_data['real_hours']                                = this.model.hidden_columns.real_hours;
                        break;
                        case 'equipment':
                        case 'ei':
                        case 'steelstructure':
                        case 'civil':
                        case 'painting':
                        case 'insulation':
                            put_data['ist_progress_total_work_value_calculation'] = this.model.hidden_columns.ist_progress_total_work_value_calculation;
                            put_data['current_execution_value_work_drawings']     = this.model.hidden_columns.current_execution_value_work_drawings;
                            put_data['real_hours']                                = this.model.hidden_columns.real_hours;
                        break;
                    }
                }

                Object.keys(put_data).forEach(key => {
                    if (put_data[key] === '') {
                        put_data[key] = null;
                    }
                });

                http.route(this.tableName + '/' + this.row.id).patch(put_data, true).then(response => {
                    if (!response.isError) {
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        this.$emit('onLoadTable');
                        this.$refs.saveModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            if (response.errorMessage[key] == 'errors.step.can_not_edit_future_step') {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]), 7500);
                            } else {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            }
                        });
                    }
                });
            } else {
                http.route(this.tableName).post(put_data, true).then(response => {
                    if (!response.isError) {
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                        this.$emit('onLoadTable');
                        this.$emit('checkSteps', response);
                        this.$refs.saveModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            if (response.errorMessage[key] == 'errors.step.step_date.check_step_date') {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]), 8000);
                            } else {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            }
                        });
                    }
                });
            }
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/global/modals/ProgressSettingStepModal.vue